import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  Typography,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Checkbox,
  Button,
  CardActionArea,Drawer,Stack
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import QrCode2TwoToneIcon from '@mui/icons-material/QrCode2TwoTone';
import getCoupons from "../api/user/getCoupons";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { green, red } from "@mui/material/colors";
import { parseISO, format } from "date-fns";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import QRCodeDialog from "../component/QRCodeDialog";
const CouponPage = () => {
  const [coupons, setCoupons] = useState([]);
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [openQRCode, setOpenQRCode] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const userContext = useContext(AuthContext);
  const user = userContext.user || {};

  const parsedDate = (inputDateString) => {
    const date = parseISO(inputDateString, "dd-MM-yyyy HH:mm", new Date());
    const formattedDate = format(date, "yyyy/MM/dd HH:mm");
    return formattedDate;
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getCoupons();
        if (response.coupons !== null) {
          setCoupons(response.coupons);
        }
      } catch (error) {
        console.error("Failed to fetch coupons", error);
      }
    }
    if (userContext.user !== null) fetchData();
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleCardClick = (couponId) => {
    setSelectedCoupons((prev) =>
      prev.includes(couponId)
        ? prev.filter((id) => id !== couponId)
        : [...prev, couponId]
    );
  };

  const handleCheckboxChange = (event, couponId) => {
    event.stopPropagation(); // Prevents the click from reaching the CardActionArea
    setSelectedCoupons((prev) =>
      prev.includes(couponId)
        ? prev.filter((id) => id !== couponId)
        : [...prev, couponId]
    );
  };

  const isSelected = (couponId) => {
    return selectedCoupons.includes(couponId);
  };
  const generateCouponString = () => {
    const qrcode= "coupon:"+userContext.user.Id+"&&"+selectedCoupons.join("&&")
    return qrcode;
  };

  return (
    <Box
      width="100%"
      height="100vh"
      sx={{
    backgroundColor: theme.palette.background.default,


  }}
    >
      <AppBar position="static" color="primary">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={handleBackButtonClick}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            alignSelf="center"
            fontSize={"h6.fontSize"}
            fontWeight={"bold"}
          >
            優惠券
          </Typography>
        </Toolbar>
      </AppBar>
      <Box m={1} />
      {/* <Stack
          direction="column"
          sx={{
            backgroundColor: "#e8e8e8",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 1,
            height: "10vh",
          }}
        >
      <Typography sx={{ fontWeight: "bold", fontSize: "h6.fontSize" }}>
            請勾選優惠券
          </Typography>
        </Stack> */}

      {userContext.user === null ? (
        <Typography
          marginTop={20}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
          align="center"
        >
          尚未登入
        </Typography>
      ) : (
        <>
          <List component={"nav"} aria-label="user coupons" sx={{paddingBottom:'20%',    backgroundColor: theme.palette.background.default}}>
            {coupons.map((coupon, index) => (
              <React.Fragment key={coupon.Id}>
                <ListItem>
                  <Checkbox
                    color="info"
                    checked={isSelected(coupon.Id)}
                    onChange={(e) => handleCheckboxChange(e, coupon.Id)}
                  />
                  <CardActionArea onClick={() => handleCardClick(coupon.Id)}>
                    <Card
                      variant="outlined"
                      style={{
                        width: "100%",
                        backgroundColor: isSelected(coupon.Id)
                          ? theme.palette.action.selected
                          : "",
                      }}
                    >
                      <CardHeader
                        avatar={
                          <Avatar
                            sx={{ width: 60, height: 60 }}
                            style={
                              coupon.IsValid
                                ? { backgroundColor: green[500] }
                                : { backgroundColor: red[500] }
                            }
                          >
                            ${coupon.Price}
                          </Avatar>
                        }
                        title={coupon.Name}
                        subheader={`有效期限 ${parsedDate(
                          coupon.StartDate
                        )}~ ${parsedDate(coupon.EndDate)}`}
                      />
                      <CardContent>
                        <Typography component="p">
                          {coupon.Description}
                        </Typography>
                        <Typography component="p">
                          {coupon.UsageCity
                            ? "限制區域:" + coupon.UsageCity
                            : ""}
                        </Typography>
                      </CardContent>
                    </Card>
                  </CardActionArea>
                </ListItem>
                {index !== coupons.length - 1 && <Divider variant="middle" />}
              </React.Fragment>
            ))}
          </List>
          <Drawer
        anchor="bottom"
        variant="permanent"

      >
        {/* <Box
          sx={{ textAlign: 'center', p: 2 }}
        >

          <Button  startIcon={<QrCode2TwoToneIcon fontSize="large" />} color="secondary" variant="contained" onClick={() => setOpenQRCode(!openQRCode)}>
            優惠券QRCODE
          </Button>
        </Box> */}
      </Drawer>

        </>
      )}
      <QRCodeDialog
        open={openQRCode}
        qrString={userContext.user !== null? generateCouponString():""}
        infoString={userContext.user !== null? "請直接於售票機掃描":"尚未登入"}
      ></QRCodeDialog>
    </Box>
    
  );
};

export default CouponPage;
